'use strict';

var DayOfWeekShape = require('../../../../_virtual/DayOfWeekShape.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var PropTypes = require('prop-types');
require('../constants.js');
var constants = require('../../../../_virtual/constants.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(PropTypes__default["default"]);

var _constants = constants.__exports;

var _default = _propTypes["default"].oneOf(_constants.WEEKDAYS);

exports["default"] = _default;
}(DayOfWeekShape.__exports));
